import { useState } from "react";

export function useSort(defaultKey) {
  const [sort, setSort] = useState({ key: defaultKey, dir: "desc" });
  const toggle = (key) => setSort((s) => (s.key === key ? { key, dir: s.dir === "desc" ? "asc" : "desc" } : { key, dir: "desc" }));
  return [sort, toggle, setSort];
}

export const sortRows = (arr, getter, dir) => [...arr].sort((a, b) => {
  const av = getter(a) || "";
  const bv = getter(b) || "";
  if (av === bv) return 0;
  const c = av < bv ? -1 : 1;
  return dir === "asc" ? c : -c;
});

export function SortHeader({ label, sortKey, sort, onToggle, testid }) {
  const active = sort.key === sortKey;
  return (
    <button
      type="button"
      onClick={() => onToggle(sortKey)}
      className={`inline-flex items-center gap-1 text-xs font-semibold hover:text-slate-900 ${active ? "text-slate-900" : "text-slate-500"}`}
      title={active && sort.dir === "desc" ? "Newest first: click for oldest first" : "Click to sort newest first"}
      data-testid={testid}
    >
      {label}
      {active && <span data-testid={`${testid}-arrow`}>{sort.dir === "desc" ? "↓" : "↑"}</span>}
    </button>
  );
}
